<template>
  <input-widget :model="model" :attribute="attribute" :label="label" :options="options" type="select2"
                :display-field="displayFieldFunction" :value-field="valueField" :hint="hint" :items="items"
                :rules="rules" @select2Select="onSelect" :disabled="disabled"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "AuctionCollectionSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      items: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
      },
      displayFieldFunction(item) {
        return this.$options.filters.attributeByMasterLanguage(item.translations, 'title')
      },
    },
  }
</script>

<style scoped>

</style>
